import '../styles/styles.scss';
import App from './app';

App.init();
